export default {"src":"/_next/static/media/google-logo-white.df33c46c.svg","height":21,"width":64,"blurWidth":0,"blurHeight":0};